import React from 'react';
import { Link } from 'react-router-dom';

export const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white border-b border-gray-200 shadow-sm">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between">
          <div className="text-xl font-bold text-primary-600">Drive On Wheels</div>
          <Link to="/login" className="text-sm text-primary-600 hover:text-primary-700 font-medium">
            Login →
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 py-10">
        <article className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 sm:p-10 prose-styled">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Privacy Policy</h1>
          <p className="text-sm text-gray-500 mb-8">Last updated: May 23, 2026</p>

          <p className="text-gray-700 leading-relaxed mb-6">
            This Privacy Policy describes Our policies and procedures on the collection, use and disclosure
            of Your information when You use the Service and tells You about Your privacy rights and how
            the law protects You.
          </p>
          <p className="text-gray-700 leading-relaxed mb-6">
            We use Your Personal Data to provide and improve the Service. By using the Service, You agree
            to the collection and use of information in accordance with this Privacy Policy.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-10 mb-4">Interpretation and Definitions</h2>

          <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-3">Interpretation</h3>
          <p className="text-gray-700 leading-relaxed mb-4">
            The words of which the initial letter is capitalized have meanings defined under the following
            conditions. The following definitions shall have the same meaning regardless of whether they
            appear in singular or in plural.
          </p>

          <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-3">Definitions</h3>
          <p className="text-gray-700 leading-relaxed mb-4">For the purposes of this Privacy Policy:</p>
          <ul className="list-disc pl-6 space-y-2 text-gray-700">
            <li><strong>Account</strong> means a unique account created for You to access our Service or parts of our Service.</li>
            <li><strong>Affiliate</strong> means an entity that controls, is controlled by or is under common control with a party, where "control" means ownership of 50% or more of the shares, equity interest or other securities entitled to vote for election of directors or other managing authority.</li>
            <li><strong>Company</strong> (referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers to Drive On Wheels, GHAZIABAD, UP.</li>
            <li><strong>Cookies</strong> are small files that are placed on Your computer, mobile device or any other device by a website, containing the details of Your browsing history on that website among its many uses.</li>
            <li><strong>Country</strong> refers to: Uttar Pradesh, India.</li>
            <li><strong>Device</strong> means any device that can access the Service such as a computer, a cellphone or a digital tablet.</li>
            <li><strong>Personal Data</strong> is any information that relates to an identified or identifiable individual.</li>
            <li><strong>Service</strong> refers to the Website.</li>
            <li><strong>Service Provider</strong> means any natural or legal person who processes the data on behalf of the Company.</li>
            <li><strong>Usage Data</strong> refers to data collected automatically, either generated by the use of the Service or from the Service infrastructure itself.</li>
            <li><strong>Website</strong> refers to Drive On Wheels, accessible from <a href="https://lms.driveonwheels.com" className="text-primary-600 hover:underline">https://lms.driveonwheels.com</a></li>
            <li><strong>You</strong> means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service.</li>
          </ul>

          <h2 className="text-2xl font-bold text-gray-900 mt-10 mb-4">Collecting and Using Your Personal Data</h2>

          <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-3">Types of Data Collected</h3>

          <h4 className="text-lg font-semibold text-gray-800 mt-4 mb-2">Personal Data</h4>
          <p className="text-gray-700 leading-relaxed mb-3">
            While using Our Service, We may ask You to provide Us with certain personally identifiable
            information that can be used to contact or identify You. Personally identifiable information may include, but is not limited to:
          </p>
          <ul className="list-disc pl-6 space-y-1 text-gray-700">
            <li>Email address</li>
            <li>First name and last name</li>
            <li>Phone number</li>
            <li>Address, State, Province, ZIP/Postal code, City</li>
            <li>Usage Data</li>
          </ul>

          <h4 className="text-lg font-semibold text-gray-800 mt-4 mb-2">Usage Data</h4>
          <p className="text-gray-700 leading-relaxed mb-3">
            Usage Data is collected automatically when using the Service. Usage Data may include information
            such as Your Device's Internet Protocol address (e.g. IP address), browser type, browser version,
            the pages of our Service that You visit, the time and date of Your visit, the time spent on those
            pages, unique device identifiers and other diagnostic data.
          </p>

          <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-3">Tracking Technologies and Cookies</h3>
          <p className="text-gray-700 leading-relaxed mb-3">
            We use Cookies and similar tracking technologies to track the activity on Our Service and store
            certain information. Tracking technologies used are beacons, tags, and scripts to collect and
            track information and to improve and analyze Our Service.
          </p>
          <p className="text-gray-700 leading-relaxed mb-3">We use both Session and Persistent Cookies for the purposes set out below:</p>
          <ul className="list-disc pl-6 space-y-1 text-gray-700">
            <li><strong>Necessary / Essential Cookies</strong> — Required for authentication and fraud prevention (Session Cookies).</li>
            <li><strong>Cookies Policy / Notice Acceptance Cookies</strong> — Identify if users have accepted the cookie policy (Persistent Cookies).</li>
            <li><strong>Functionality Cookies</strong> — Remember choices You make, such as language preferences or login details (Persistent Cookies).</li>
          </ul>

          <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-3">Use of Your Personal Data</h3>
          <p className="text-gray-700 leading-relaxed mb-3">The Company may use Personal Data for the following purposes:</p>
          <ul className="list-disc pl-6 space-y-1 text-gray-700">
            <li>To provide and maintain our Service, including to monitor usage.</li>
            <li>To manage Your Account: registration and management of You as a user.</li>
            <li>For the performance of a contract: development, compliance and undertaking of the contract for the products, items or services You have purchased.</li>
            <li>To contact You by email, telephone calls, SMS, or other equivalent forms of electronic communication regarding updates or informative communications.</li>
            <li>To provide You with news, special offers and general information about other goods, services and events.</li>
            <li>To manage Your requests: To attend and manage Your requests to Us.</li>
            <li>For business transfers: We may use Your information to evaluate or conduct a merger, divestiture, restructuring, reorganization, dissolution, or other sale or transfer of some or all of Our assets.</li>
            <li>For other purposes: We may use Your information for other purposes, such as data analysis, identifying usage trends, determining the effectiveness of our promotional campaigns and to evaluate and improve our Service.</li>
          </ul>

          <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-3">Retention of Your Personal Data</h3>
          <p className="text-gray-700 leading-relaxed mb-3">
            The Company will retain Your Personal Data only for as long as is necessary for the purposes set
            out in this Privacy Policy. We will retain and use Your Personal Data to the extent necessary to
            comply with our legal obligations (for example, if we are required to retain your data to comply
            with applicable laws), resolve disputes, and enforce our legal agreements and policies.
          </p>
          <p className="text-gray-700 leading-relaxed mb-3">Data is retained for up to <strong>24 months</strong> after account closure or last activity for the following categories:</p>
          <ul className="list-disc pl-6 space-y-1 text-gray-700">
            <li>User account information</li>
            <li>Support tickets and correspondence</li>
            <li>Analytics and usage data</li>
            <li>Server logs (for security monitoring)</li>
          </ul>

          <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-3">Delete Your Personal Data</h3>
          <p className="text-gray-700 leading-relaxed mb-3">
            You have the right to delete or request that We assist in deleting the Personal Data that We have
            collected about You. Our Service may give You the ability to delete certain information about You
            from within the Service. You may also contact Us to request access to, correct, or delete any
            personal information that You have provided to Us.
          </p>
          <p className="text-gray-700 leading-relaxed mb-3">
            For detailed instructions, see our{' '}
            <Link to="/data-deletion" className="text-primary-600 hover:underline">Data Deletion page</Link>.
          </p>

          <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-3">Security of Your Personal Data</h3>
          <p className="text-gray-700 leading-relaxed mb-3">
            The security of Your Personal Data is important to Us, but remember that no method of
            transmission over the Internet, or method of electronic storage is 100% secure. While We strive
            to use commercially acceptable means to protect Your Personal Data, We cannot guarantee its
            absolute security.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-10 mb-4">Children's Privacy</h2>
          <p className="text-gray-700 leading-relaxed mb-3">
            Our Service does not address anyone under the age of 16. We do not knowingly collect personally
            identifiable information from anyone under the age of 16. If You are a parent or guardian and You
            are aware that Your child has provided Us with Personal Data, please contact Us. If We become
            aware that We have collected Personal Data from anyone under the age of 16 without verification
            of parental consent, We take steps to remove that information from Our servers.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-10 mb-4">Links to Other Websites</h2>
          <p className="text-gray-700 leading-relaxed mb-3">
            Our Service may contain links to other websites that are not operated by Us. If You click on a
            third party link, You will be directed to that third party's site. We strongly advise You to
            review the Privacy Policy of every site You visit. We have no control over and assume no
            responsibility for the content, privacy policies or practices of any third party sites or
            services.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-10 mb-4">Changes to this Privacy Policy</h2>
          <p className="text-gray-700 leading-relaxed mb-3">
            We may update Our Privacy Policy from time to time. We will notify You of any changes by posting
            the new Privacy Policy on this page and updating the "Last updated" date at the top of this
            Privacy Policy. You are advised to review this Privacy Policy periodically for any changes.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-10 mb-4">Contact Us</h2>
          <p className="text-gray-700 leading-relaxed mb-3">
            If you have any questions about this Privacy Policy, You can contact us:
          </p>
          <ul className="list-disc pl-6 space-y-1 text-gray-700">
            <li>By email: <a href="mailto:padeyvarun03@gmail.com" className="text-primary-600 hover:underline">padeyvarun03@gmail.com</a></li>
            <li>By visiting this page on our website: <a href="https://lms.driveonwheels.com/" className="text-primary-600 hover:underline">https://lms.driveonwheels.com/</a></li>
            <li>By phone number: +91 9818864690</li>
          </ul>
        </article>
      </main>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200 mt-10">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 py-6 flex flex-wrap items-center justify-between text-sm text-gray-500">
          <p>&copy; {new Date().getFullYear()} Drive On Wheels. All rights reserved.</p>
          <div className="flex gap-4">
            <Link to="/privacy-policy" className="hover:text-primary-600">Privacy Policy</Link>
            <Link to="/terms-and-conditions" className="hover:text-primary-600">Terms and Conditions</Link>
            <Link to="/data-deletion" className="hover:text-primary-600">Data Deletion</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};
